import React,{ Fragment }  from 'react';
import PropTypes from 'prop-types';

import Loading from '../../../shared/components/misc/Loading';
import classNames from 'classnames'

import Header from './Header';
import Amount from './Amount';
import Action from './Action';
import Info from './Info';

const propTypes = {
  cardClassName:     PropTypes.string,
  headerText:        PropTypes.oneOfType([ PropTypes.string, PropTypes.object]).isRequired,
  amount:            PropTypes.number.isRequired,
  emphasisCharacter: PropTypes.string,
  hasOverdue:        PropTypes.bool.isRequired,
  actionType:        PropTypes.string.isRequired,
  actionLabel:       PropTypes.string.isRequired,
  buttonClassName:   PropTypes.string,
  onClick:           PropTypes.func,
  infoText:          PropTypes.string.isRequired,
  infoClassName:     PropTypes.string,
  loading:           PropTypes.bool.isRequired,
  headerOnly:         PropTypes.bool
};

const HeroActionInfo = ({
  cardClassName,
  headerText,
  amount,
  emphasisCharacter,
  hasOverdue,
  actionType,
  actionLabel,
  buttonClassName,
  onClick,
  infoText,
  infoClassName,
  loading,
  dataPath,
  headerOnly= false,
}) => {
  if (loading) return <Loading />;

  const getCardClassName = () => classNames('cardSection _alignCenter', cardClassName);
  const renderBody = () => {
    if(headerOnly) return
    return (
      <Fragment>
        <Amount
          hasOverdue={hasOverdue}
          amount={amount}
          emphasisCharacter={emphasisCharacter}
        />
        <Action
          type={actionType}
          actionLabel={actionLabel}
          buttonClassName={buttonClassName}
          onClick={onClick}
          dataPath={dataPath}
        />
        <Info infoText={infoText} className={infoClassName} />
      </Fragment>
    );
  }

  return (
    <section className={getCardClassName()}>
      <Header text={headerText} containerFontClass='headline' />
      {renderBody()}
    </section>
  );
}

HeroActionInfo.propTypes = propTypes;
export default HeroActionInfo;



// WEBPACK FOOTER //
// ./src/features/PrincipalPaydown/components/Hero/HeroActionInfo.js